class Loading {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const loadElement = '.' + this.el;
    // $(loadElement).addClass('is-load');
    // $('.js-loading-anime').fadeOut();
  }
}